import { msg } from '@lingui/core/macro';

export const RECURRING_SWITCH_TEXT = msg`Repeat every week?`;
export const RECURRING_SWITCH_TEXT_LONG = msg`Would you like to repeat this service each week?`;
export const RECURRING_SWITCH_INFO_TITLE = msg`Repeat every week`;
export const RECURRING_SWITCH_INFO_CONTENT = msg`Recurring bookings allow you to choose whether you want a booking to repeat automatically every week. With this feature, bookings take place on the same day of the week and they'll repeat on an ongoing basis. You can discontinue recurring bookings at any time.`;
